import { IPaintStyle } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IPaintStylePropertyEditable {
  paintStyle(): IPropertyEditable<IPaintStyle>;
}

export function instanceOfIPaintStylePropertyEditable(instance: any): instance is IPaintStylePropertyEditable {
  return instance
      && instance.paintStyle
      && instanceOfIPropertyEditable<IPaintStyle>(instance.paintStyle());
}
